var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eqs-email"},[_c('EqsText',_vm._g(_vm._b({attrs:{"basic-rules":_vm.$options.rules}},'EqsText',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }